<template>
  <div>
    <div class="mt-3 elevation-12 grey lighten-4">
      <h2 class="px-3 pt-3">{{ $t("newTrip.selfOrOtherUser") }}</h2>
      <v-row class="text-center">
        <v-spacer />
        <v-col cols="12" md="4" class="choose-box elevation-5">
          <h3>{{ $t("newTrip.forSelf") }}</h3>
          <v-icon size="150px">perm_identity</v-icon>
          <br />
          <v-btn v-on:click="tripSelf()">{{ $t("global.choose") }}</v-btn>
        </v-col>
        <v-spacer />
        <v-col cols="12" md="4" class="choose-box elevation-5"
          ><h3>{{ $t("newTrip.forOther") }}</h3>
          <v-icon size="150px">supervisor_account</v-icon>
          <br />
          <v-select v-model="selectedUser" :items="users" :label="$t('global.worker')" :error-messages="errorMessages">
            {{ $t("newTrip.chooseWorker") }}
          </v-select>
          <v-btn v-on:click="tripOther()">{{ $t("global.choose") }}</v-btn>
        </v-col>
        <v-spacer />
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectPerson",
  data: () => ({
    users: [],
    selectedUser: null,
    errorMessages: []
  }),
  watch: {
    selectedUser(value) {
      if (value != null) {
        this.errorMessages = [];
      }
    }
  },
  computed: {
    userId: function() {
      if (typeof this.$store.getters["userProperties"].context_user_id !== "undefined") {
        return this.$store.getters["userProperties"].context_user_id.toString();
      }
      return this.$store.getters["userProperties"].user_id.toString();
    }
  },
  methods: {
    tripSelf: function() {
      this.$store.dispatch("DelegationOrder/setUser", this.userId);
      this.nextState();
    },
    tripOther: function() {
      if (this.selectedUser == null) {
        this.errorMessages = [this.$t("newTrip.chooseWorker")];
      } else {
        this.$store.dispatch("DelegationOrder/setUser", this.selectedUser);
        this.nextState();
      }
    },
    nextState: function() {
      this.$router.push({ path: "/new-trip/select-service" });
    }
  },
  created() {
    this.$store.dispatch("DelegationOrder/newTripStart");
    this.nextState(); //TODO NA TEN MOMENT widok ten nie jest potrzebny i niczego nie wnosi
    this.axios.get("delegation-order/available-users").then(response => {
      for (let prop of response.data) {
        this.users.push({ text: prop.fullName, value: prop.id });
      }
      if (this.users.length === 1) {
        this.$store.dispatch("DelegationOrder/setUser", this.users[0].value);
        this.nextState();
      }
    });
  }
};
</script>

<style scoped></style>
